function getMonthsTexts(t: Function) {
  return [
    t("calendar.january"),
    t("calendar.february"),
    t("calendar.march"),
    t("calendar.april"),
    t("calendar.may"),
    t("calendar.june"),
    t("calendar.july"),
    t("calendar.august"),
    t("calendar.september"),
    t("calendar.october"),
    t("calendar.november"),
    t("calendar.december"),
  ];
}

function getDaysTexts(t: Function) {
  return [
    t("gantt.monday"),
    t("gantt.tuesday"),
    t("gantt.wednesday"),
    t("gantt.thursday"),
    t("gantt.friday"),
    t("gantt.saturday"),
    t("gantt.sunday"),
  ];
}

function isRestDay(day: number) {
  return day === 5 || day === 6;
}

export { getDaysTexts, isRestDay, getMonthsTexts };
